import { useState, useEffect } from "react";
import { useAuth } from "@/App";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Globe } from "lucide-react";

export default function SubscriptionFilter({ value, onChange }) {
  const { api } = useAuth();
  const [subs, setSubs] = useState([]);

  useEffect(() => {
    api()
      .get("/subscriptions")
      .then((res) => setSubs(res.data))
      .catch(() => {});
  }, [api]);

  if (subs.length <= 1) return null;

  return (
    <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
      <SelectTrigger
        className="w-full sm:w-56 bg-[var(--n-card)] border-[var(--n-border-2)] text-sm"
        data-testid="subscription-filter"
      >
        <div className="flex items-center gap-2 truncate">
          <Globe className="w-3.5 h-3.5 text-[var(--hig-accent)] shrink-0" />
          <SelectValue placeholder="All Subscriptions" />
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Subscriptions</SelectItem>
        {subs.map((s) => (
          <SelectItem key={s.id} value={s.id}>
            {s.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
